export interface Translation {
  _id?: string
  language: string
  title: string
  description: string
}

export interface TourType {
  _id?: string
  title: string
  description: string
  status: 'active' | 'inactive'
  translations: Translation[]
}

export const initialTourType: Omit<TourType, '_id'> = {
  title: '',
  description: '',
  status: 'active',
  translations: []
}